import "bootstrap/dist/css/bootstrap.css";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import './index.css';
import { router } from './router/router';

import "react-modal-video/css/modal-video.min.css";
import "swiper/css";
import "swiper/css/effect-cards";
import Preloader from "./components/common/preloader/preloader";
import ScrollTop from "./components/common/scroll-top";
import "./styles/css/app.css";
import "./styles/css/main.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    <ScrollTop />
    <Preloader />
  </React.StrictMode>
);

